import React, { Component, Fragment } from 'react'
import Spinner from './Spinner'
import axios from 'axios'
import isEqual from 'lodash/isEqual'
import debounce from 'lodash/debounce'
import { connect } from 'react-redux'
import { getUniqueId } from '@patternfly/react-core'

const SparqlClient = require('sparql-http-client/SimpleClient')

//import spcache from '../spcache';

//let cache = spcache;
let cache = {}
if (document.cache != null) {
  cache = document.cache
}

const CancelToken = axios.CancelToken

window.top.saveCache = function () {
  // var s = 'export default ';
  //var s = 'document.cache=';
  var s = ''
  s += JSON.stringify(cache)
  console.log(s)

  window.top.downloadObjectAsJson(s, 'spcache')
}

class Widget extends Component {
  constructor(props) {
    super(props)
    this.resolveTemplateVariableInQueryDebounce = debounce(
      this.resolveTemplateVariableInQuery,
      2000
    )
    this.useLoadingWidget = false
    if (window.top.url == null) {
      this.createSparqlFunction()
    }
  }

  state = {
    loading: false,
  }

  getUrl() {
    try {
      let url = '/api/sparql/' + this.props.repoURL
      if (this.props.repoURL.startsWith('http')) {
        // request sparql endpoint directly
        url = this.props.repoURL
      }
      var modus = false
      if (window.location.host === 'localhost:3000') {
        modus = true
      }
      //  var modus=false; //debug

      if (
        this.props.localRepoURL != null &&
        this.props.localRepoURL !== '' &&
        modus
      ) {
        url = this.props.localRepoURL
      }
      window.top.url = url
      console.log('returning url :' + url)
      return url
    } catch (e) {
      console.log('error creating url' + e)
    }
    return null
  }
  createSparqlFunction2() {
    // gebruikt door bb widgets in iframe situation
    var url = this.getUrl()
    window.top.query = function (query, success, errorRV) {
      // console.log("query via window top ",query,success,errorRV);

      let encodedQuery = encodeURIComponent(query)
      let data = {
        query: query,
      }
      data = 'infer=false&sameAs=false&query=' + encodedQuery
      let headers = {
        Authorization: `Bearer ${localStorage.getItem('kvk-vb-token')}`,
      }
      headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
        Accept: 'application/sparql-results+json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods':
          'GET, POST, PATCH, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
        // 'credentials': 'include',
        // 'withCredentials': 'true'
      }

      axios.defaults.headers.post['Content-Type'] =
        'application/x-www-form-urlencoded'
      axios.defaults.withCredentials = true
      axios.defaults.credentials = 'include'
      axios({
        method: 'post',
        url,
        data,
        headers,
        cancelToken: new CancelToken((c) => {
          this.cancel = c
        }),
      })
        .then((response) => {
          if (success) {
            success.call(this, response.data)
          }
        })
        .catch((error) => {
          //  console.log(error,query);
          if (errorRV) {
            errorRV.call(this, error)
          }
        })
    }
  }

  createSparqlFunction() {
    // gebruikt door bb widgets in iframe situation

    if (true) {
      this.createSparqlFunction2()
      return
    }
    var endpointUrl = this.getUrl()
    window.top.query = async function (query, success, errorRV) {
      try {
        const client = new SparqlClient({ endpointUrl })
        const stream = await client.query.select(query, {
          operation: 'postUrlencoded',
        })
        var data = await stream.json()

        if (success) {
          success.call(this, data)
        }
      } catch (e) {
        console.log(e)
        if (errorRV != null) {
          errorRV.call(this, 'error sparql endpoint')
        }
      }
    }
  }

  async loadData2(query, encodedQueryForCache, endpointUrl) {
    // goed op basis van sparql client

    //console.log("load data 2",endpointUrl,axios);

    try {
      if (endpointUrl == null) endpointUrl = this.getUrl()
      const client = new SparqlClient({ endpointUrl })
      const stream = await client.query.select(query, {
        operation: 'postUrlencoded',
      })
      var data = await stream.json()

      if (data != null) {
        if (encodedQueryForCache != null) {
          cache[encodedQueryForCache] = data
        }
        this.setState({ data: data, loading: false, executedSparql: query })
      }
    } catch (e) {
      console.log(e, this.getUrl())
      alert(this.props.sparqlErrorMessage)
    }
  }

  runJSInQuery(query) {
    try {
      if (query == null) return null
      let b = query.includes('<script>')
      if (b) {
        console.log('FOUND JS in query')

        let codes = query.split('<script>')
        let nquery = ''
        for (let n in codes) {
          if (n == 0) {
            nquery = codes[n];
            continue;
          }
          let code = codes[n]
          
          let codeQuery = code.split('</script>')
          let evalcode = codeQuery[0]
        //  console.log(code,n,evalcode);
          let evalCode2 = new Function(evalcode)() //eslint-disable-line no-new-func
          if (evalCode2 == null) {
            evalCode2 = ''
          }
          let subQuery2 = codeQuery[1]
          nquery += evalCode2 + subQuery2
        }
        console.log('returning ', nquery)
        return nquery
      }
    } catch (error) {
      console.log('error parsing js in query ', error, query)
    }

    return query
  }

  loadData(query) {
    // console.log(query);
    var me = this

    if (!this.props.repoURL) return console.log('Repo URL is not set!')

    if (query) {
      // default use proxy server
      query = this.runJSInQuery(query)
      let url = '/api/sparql/' + this.props.repoURL
      let encodedQuery = encodeURIComponent(query)
      let data = {
        query: query,
      }
      let headers = {
        Authorization: `Bearer ${localStorage.getItem('kvk-vb-token')}`,
      }

      if (this.props.repoURL.startsWith('http')) {
        // request sparql endpoint directly
        url = this.props.repoURL
        data = 'infer=false&sameAs=false&query=' + encodedQuery
        headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
          Accept: 'application/sparql-results+json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods':
            'GET, POST, PATCH, PUT, DELETE, OPTIONS',
          'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
          // 'credentials': 'include',
          // 'withCredentials': 'true'
        }
      }

      //console.log(url);

      // headers['credentials']= 'include';
      headers['withCredentials'] = 'true'

      // headers['Cookie']='JSESSIONID=02615904FAE985C0AC61B3DE2ACD8758';

      let modus = this.props.mode
      if (window.location.host === 'localhost:3000') {
        modus = true
      }
      //modus=false; // debug
      if (this.props.localRepoURL != null && modus) {
        if (this.props.localRepoURL.length > 4) {
          url = this.props.localRepoURL
        }
      }

      try {
        if (this.state.loading) {
          this.cancel()
        }
      } catch (e) {}

      //console.log("set loading");
      this.setState({
        loading: true,
        message: null,
      })

      me = this

      let useCache = true
      if (useCache) {
        let results = cache[encodedQuery]
        if (results) {
          let uid = getUniqueId()
          //  console.log('from cache');
          setTimeout(() => {
            me.setState({
              data: results,
              loading: false,
              id: uid,
              executedSparql: query,
            })
          }, 0)

          return
        }
      }

      axios.defaults.headers.post['Content-Type'] =
        'application/x-www-form-urlencoded'
      //axios.defaults.headers.post['Access-Control-Allow-Origin'] ='*';

      if (window.location.host === 'xxxxlocalhost:3000') {
        //console.log("Debugging ");
        this.loadData2(query, encodedQuery, this.getUrl())
        return
      }

      //console.log("querying with ",query,headers);
      axios.defaults.withCredentials = true
      axios.defaults.credentials = 'include'
      // console.log("really sparqling ",query);
      axios({
        method: 'post',
        url,
        data,
        cancelToken: new CancelToken((c) => {
          this.cancel = c
        }),
      })
        .then((response) => {
          if (useCache) {
            cache[encodedQuery] = response.data
          }
          // console.log("this setting state. what is this?",this);
          this.setState({ data: response.data, loading: false })
        })
        .catch((error) => {
          console.log('axios errror. try one more time ', url, error)
          if (error.__CANCEL__ === true) {
            return
          }

          axios.defaults.withCredentials = true
          axios.defaults.credentials = 'include'
          axios({
            method: 'post',
            url,
            data,
            cancelToken: new CancelToken((c) => {
              this.cancel = c
            }),
          })
            .then((response) => {
              if (useCache) {
                cache[encodedQuery] = response.data
              }
              this.setState({ data: response.data, loading: false })
            })
            .catch((error) => {
              if (error.response) {
                console.log('error retreiving ', error.response.status)
                if (error.response.status === 400) {
                  console.log(
                    'arguably wrong sparql. Skipping this error ',
                    query
                  )
                  return
                }
              }
              console.log(
                'axios errror... second time ',
                error,
                query,
                me.props.sparqlErrorMessage
              )

              if (me.props.sparqlErrorMessage != null) {
                alert(me.props.sparqlErrorMessage)
              } else {
                if (error === 'Error: Network Error') {
                  alert('error: cannot connect to server')
                }
              }
            })
        })
    }
  }

  resolveTemplateVariableInQuery = (changedPublishProp) => {
    let query = this.props.query;

    
    if (this.props.withinSelectedTab === false) {
      return
    } // geen queries uitvoeren voor niet zichtbare tabs
    if (!query) {
      return
    }

   // console.log(query);

    //const regex = /{{\S*}}/g;
    const regex = /{{[A-Za-z0-9|:./]*}}/g
    let subscribeProps = query.match(regex)

    if (!subscribeProps) {
      if (changedPublishProp) {
        return
      }
      // console.log("load data:"+query.substring(0,30));
      // geen variabelen meer in de query?
      return this.loadData(query)
    }

  //  console.log(subscribeProps);
    subscribeProps = subscribeProps.map((f) => f.replace(/[{}]/g, ''))
    var subscribeProps2 = subscribeProps.map((f) => f.split('||')).flat()

    //console.log(subscribeProps2);
    subscribeProps2 = subscribeProps2.map((f) => f.split('::')[0])
    //
    subscribeProps = [...new Set(subscribeProps)] // remove duplicates
    subscribeProps2 = [...new Set(subscribeProps2)] // remove duplicates
    //console.log(subscribeProps2,changedPublishProp);
    if (changedPublishProp && !subscribeProps2.includes(changedPublishProp)) {
      //this.setState({ data: {results:{bindings:[]},head:{vars:[]}}, loading: false  });
      return
    }
     //console.log(query.substring(0,20),subscribeProps,changedPublishProp,!subscribeProps.includes(changedPublishProp));

    for (var i = 0; i < subscribeProps.length; i++) {
      let subscribeProp = subscribeProps[i]
      let subscribeValue = this.props.pubsub[subscribeProp]
      if (subscribeValue == null) {
        // console.log("found empty property or composed properties",subscribeProp);
      }

      if (subscribeProp.includes('||')) {
        let subscribeProp2 = subscribeProp.split('||')[0]
        subscribeValue = this.props.pubsub[subscribeProp2]
        if (subscribeValue === 'http://www.buildingbits.nl/reset') {
          subscribeValue = null
        }

        //  console.log(subscribeProp,subscribeValue,subscribeProp.split(":")[1]);
        if (subscribeValue == null) {
          var prop = subscribeProp.split('||')[1].split('||')[0].split('::')[0]
          subscribeValue = this.props.pubsub[prop]
          if (subscribeValue === 'http://www.buildingbits.nl/reset') {
            subscribeValue = null
          }
        }
      }

      if (subscribeProp.includes('::') && subscribeValue == null) {
        let subscribeProp2 = subscribeProp.split('::')[0]
        subscribeValue = this.props.pubsub[subscribeProp2]
        if (subscribeValue === 'http://www.buildingbits.nl/reset') {
          subscribeValue = null
        }
        // console.log(subscribeProp,subscribeValue,subscribeProp.split(":")[1]);
        if (subscribeValue == null) {
          subscribeValue = subscribeProp.split('::')[1]
        }
        //  console.log(subscribeProp,subscribeValue);
      }

      //console.log(subscribeProp,subscribeValue);
      if (!subscribeValue) {
        return this.setState({
          //message: `Kies een ${subscribeProp}`
          message: '',
        })
      }
      // console.log(subscribeProp,subscribeValue);
      subscribeProp = subscribeProp.replaceAll('||', '\\|\\|')
      let regex2 = new RegExp(`{{${subscribeProp}}}`, 'g')
      // var o={q:query};

   //  console.log("changing query ",query,regex2,subscribeValue);
      try {
        query = query.replace(regex2, subscribeValue)
        // console.log("results ",query);
      } catch (e) {
        console.log(
          'ERROR ',
          query,
          subscribeValue,
          subscribeProps,
          this.props.pubsub[subscribeProp]
        )
      }
      // o.q2=query;
      //console.log(o,subscribeProp);
    }
    this.setState({ loading: true })
   // console.log("changed query so loading",query.substring(0,20),{query:query});
    this.loadData(query)
  }

  componentDidMount() {
    let variables = this.props.definition.variables
    let queryDefinition =
      variables && variables.find((variable) => variable.name === 'query')
    if (!queryDefinition) return
    if (this.props.withinSelectedTab === false) return
    this.resolveTemplateVariableInQuery()
  }

  componentDidUpdate(prevProps) {
    let variables = this.props.definition.variables
    let queryDefinition =
      variables && variables.find((variable) => variable.name === 'query')
    if (!queryDefinition) return

    if (prevProps.repoURL !== this.props.repoURL) {
      this.resolveTemplateVariableInQueryDebounce()
    } else if (this.props.withinSelectedTab !== prevProps.withinSelectedTab) {
      // if (this.props.withinSelectedTab && !this.state.data){
      if (this.props.withinSelectedTab) {
        this.resolveTemplateVariableInQuery()
      }
    } else if (prevProps.query !== this.props.query) {
      this.resolveTemplateVariableInQuery()
    } else if (!isEqual(prevProps.pubsub, this.props.pubsub)) {
      let changedPublishProp

      Object.keys(this.props.pubsub).forEach((key) => {
        if (prevProps.pubsub[key] !== this.props.pubsub[key]) {
          changedPublishProp = key
        }
      })

      this.resolveTemplateVariableInQuery(changedPublishProp)
    }
  }

  publish = (prop, value) => {
    this.props.dispatch({
      type: 'PUBLISH',
      data: {
        [prop]: value,
      },
    })
  }

  setLoading = (loading) => this.setState({ loading })

  render() {
    const loading = Boolean(this.state?.loading)
    if (this.state == null) return null

    return (
      <Fragment>
        <Spinner loading={loading} />

        {React.cloneElement(this.props.children, {
          ...this.state,
          ...this.props,
          setLoading: this.setLoading,
          publish: this.publish,
        })}
      </Fragment>
    )
  }

  /*
const mapStateToProps = state => ({
  pubsub: state.pubsub
});
*/
}

const mapStateToProps = function (state, ownprops) {
  //console.log(ownprops);
  return {
    pubsub: state.pubsub,
    userActionsDisabled: Boolean(state.project.userActionsDisabled),
  }
}

export default connect(mapStateToProps)(Widget)
